<h1 mat-dialog-title [attr.data-cy]="'vvddvdd_h1_1_4_'"
    >Tierarzt {{ tierarzt && tierarzt.tierarzt_id ? tierarzt.vorname + " " + tierarzt.nachname : "" }}</h1
>
<div mat-dialog-content>
    <kiene-autocomplete
        *ngIf="!edit"
        [panelWidth]="'50%'"
        [apiUrl]="'benutzer/'"
        [params]="vetParams"
        [placeholder]="'Tierarzt'"
        [displayFields]="['vorname', 'nachname']"
        (elementSelected)="setTierarzt($event)"
        [attr.data-cy]="'vvddvdd_kiene-autocomplete_1_5_'"
    ></kiene-autocomplete>

    <kiene-autocomplete
        [focus]="false"
        [displayField]="'bezeichnung'"
        [panelWidth]="'50%'"
        [apiUrl]="'lagerplatz/'"
        [kieneObject]="lagerplatz"
        [params]="params"
        [placeholder]="'Lagerplatz'"
        (elementSelected)="setLagerplatz($event)"
        [attr.data-cy]="'vvddvdd_kiene-autocomplete_2_5_'"
    ></kiene-autocomplete>

    <mat-form-field style="margin-right: 12px">
        <mat-label>Tierarztnummer</mat-label>
        <input matInput type="number" [formControl]="vetNumberCtrl" [attr.data-cy]="'vvddvdd_input_1_1_'" />
    </mat-form-field>
    <mat-form-field style="margin-right: 12px">
        <mat-label>QS Alias</mat-label>
        <input matInput type="text" [formControl]="qsAliasCtrl" [attr.data-cy]="'vvddvdd_input_2_1_'" />
    </mat-form-field>
    <mat-form-field style="margin-right: 12px">
        <mat-label>N&auml;chste Abgabebelegnr</mat-label>
        <input matInput type="number" [formControl]="abgabebelegNrCtrl" [attr.data-cy]="'vvddvdd_input_3_1_'" />
    </mat-form-field>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="cancel()" [attr.data-cy]="'vvddvdd_button_1_0_'">Abbrechen</button>
    <button mat-flat-button color="accent" cdkFocusInitial (click)="save()" [attr.data-cy]="'vvddvdd_button_2_0_'"
        >Speichern</button
    >
</div>
